import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type UpdateProductUpdatePayload = {
  userId: number;
  updateId: number;
  body: any;
  productId: string;
};
type UpdateProductUpdateResponse = any;

export const updateProductUpdate = async (
  payload: UpdateProductUpdatePayload
): Promise<UpdateProductUpdateResponse> => {
  try {
    const { data } = await apiService.patch<UpdateProductUpdateResponse>(
      `/users/${payload.userId}/updates/${payload.updateId}`,
      payload.body
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
